module.exports = __webpack_public_path__ + "assets/media/Louis_Granet_UK.d190ab70-ps.mp4";